<template>
  <div id="customTable">
    <custom-params @query="query" v-if="type === 1" :userSeach="userSeach"></custom-params>
    <custom-params-compare @query="query" v-if="type === 2" :organizeSeach="organizeSeach"></custom-params-compare>
    <div class="userMain">
      <div class="userMainTree">
        <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText">
        </el-input>
        <el-tree
          class="filter-tree"
          :data="treeData"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :default-expand-all='false'
          :filter-node-method="filterNode"
          ref="tree">
        </el-tree>
      </div>
      <div class="userMainTable">
        <custom-table
          :pagetype="pagetype"
          @query="query"
          :columnName="columnName"
          :tableData="tableData"
          :report-code="$route.fullPath"
          :path="path"
          @init='init'
          :userSeach='userSeach'
          :organizeSeach='organizeSeach'
        ></custom-table>
        <custom-pagination :totalRows="totalRows" :pageNo="pageObj.pageNo" :pageSize="pageObj.pageSize" @changePage="changePage" @changeSize="changeSize"></custom-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { methodPost } from '../../api/request.js'
import customParams from './customParams/indexTimes.vue'
import customParamsCompare from './customParams/indexTimesCompare.vue'
import customTable from './customTable/index.vue'
import customPagination from './customPagination/index.vue'
import { userManagement, organization } from '../../assets/json/tableHead.js'
export default {
  name: 'userManagementList',
  components: {
    customParams,
    customTable,
    customPagination,
    customParamsCompare
  },
  props: {
  },
  data() {
    return {
      type: 1,
      filterText: '',
      params: {},
      path: '',
      columnName: '',
      tableData: [],
      totalRows: 0,
      pageObj: {
        pageNo: 1,
        pageSize: 100
      },
      queryObj: {},
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      roleListLink: [],
      organizeListLink: [],
      organizeSeach: {
        organizeName: '',
        organizeCode: '',
        staffName: '',
        upOrganizeName: ''
      },
      userSeach: {
        status: '1', // 状态
        account: '',
        roleCode: '',
        userName: '',
        accountType: ''
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    const urlhash = window.location.hash
    if (urlhash.indexOf('#/userManagementList/index') === 0) { // 用户管理
      this.path = '/user/list'
      this.columnName = userManagement
      this.type = 1
      this.pagetype = 'userManagement'
      this.params = {
        status: this.userSeach.status,
        account: this.userSeach.account,
        roleCode: this.userSeach.roleCode,
        userName: this.userSeach.userName,
        pageNo: this.queryObj.pageNo,
        pageSize: this.pageObj.pageSize
      }
      this.init(this.params, this.path)
      this.treeEvent()
    } else if (urlhash.indexOf('#/organizationManagement/index') === 0) { // 组织管理
      this.path = '/sysOrganize/findOrganizeList'
      this.columnName = organization
      this.type = 2
      this.pagetype = 'organizationManagement'
      this.params = {
        organizeName: this.organizeSeach.organizeName,
        organizeCode: this.organizeSeach.organizeCode,
        staffName: this.organizeSeach.staffName,
        upOrganizeName: this.organizeSeach.staffName,
        pageNo: this.queryObj.pageNo,
        pageSize: this.pageObj.pageSize
      }
      this.init(this.params, this.path)
      this.treeEvent()
    }
  },
  mounted() {
    this.$eventBus.$on('refresh-custom-table', () => {
      this.reload()
    })
  },
  methods: {
    /* 查询条件 */
    query(params) {
      if (!params) {
        this.init(params, this.path)
      } else {
        this.queryObj = params
        this.queryObj = Object.assign({}, this.queryObj, { pageNo: 1, pageSize: this.pageObj.pageSize })
        this.init(this.queryObj, this.path)
      }
      this.treeEvent()
    },
    /* 初始化数据*/
    init(params, url) {
      this.tableData = []
      this.totalRows = 0
      methodPost(url, params).then(res => {
        if (res.code === 0) {
          this.tableData = []
          res.data.data.forEach((item) => {
            if (item.status === 1) {
              item.status = '有效'
            } else {
              item.status = '无效'
            }
            if (item.accountType === 1) {
              item.accountType = '达能集团帐号'
            } else {
              item.accountType = '系统平台帐号'
            }
            this.tableData.push(item)
          })
          this.totalRows = res.data.totalRows
          this.pageObj.pageNo = res.data.pageNo
          this.pageObj.pageSize = res.data.pageSize
        } else {
          this.$message.error(res.message)
        }
      }).catch(res => {
        console.log(res)
      })
    },
    /* 翻页 */
    changePage(pageObj) {
      this.queryObj = Object.assign({}, this.queryObj, pageObj)
      this.init(this.queryObj, this.path)
    },
    /* 切换每页展示条数 */
    changeSize(sizeObj) {
      this.queryObj = Object.assign({}, this.queryObj, sizeObj)
      this.init(this.queryObj, this.path)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    treeEvent(params) {
      this.treeData = []
      methodPost('/sysOrganize/getSysOrganizeTree', params).then(res => {
        if (res.code === 0) {
          // this.treeData[0].label = res.data.label
          // this.treeData[0].id = 1
          // this.treeData[0].children = res.data.children
          this.treeData = res.data
        } else {
          this.$message.error(res.message)
        }
      }).catch(res => {
        console.log(res)
      })
    },
    // 点击查询
    handleNodeClick(data) {
      this.init({ organizeCode: data.code, pageNo: this.queryObj.pageNo,
        pageSize: this.pageObj.pageSize }, this.path)
    },
    reload() {
      let params = {}
      if (this.type === 1) {
        params = {
          status: this.userSeach.status,
          account: this.userSeach.account,
          roleCode: this.userSeach.roleCode,
          userName: this.userSeach.userName,

          pageNo: this.queryObj.pageNo,
          pageSize: this.pageObj.pageSize
        }
      } else if (this.type === 2) {
        params = {
          organizeName: this.organizeSeach.organizeName,
          organizeCode: this.organizeSeach.organizeCode,
          staffName: this.organizeSeach.staffName,
          upOrganizeName: this.organizeSeach.staffName,
          pageNo: this.queryObj.pageNo,
          pageSize: this.pageObj.pageSize
        }
      }
      this.init(params, this.path)
      this.treeEvent()
    }

  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.userMain{
   display: flex;
    display: -mox-flex;
    display: -webkit-flex;
    display: -ms-flexbox;
    display:block\9;
    max-width:100%;
    flex: 1;
    margin:0 20px;
    background:#fff;
}
.userMainTree{
  width:210px;
  background:#fff;
  padding:10px 0 10px 10px;
  overflow-y:scroll;
  height: 97%;
}
.userMainTable{
  display: flex;
  display: -mox-flex;
  display: -webkit-flex;
  display: -ms-flexbox;
  display:block\9;
  overflow-y:hidden;
  // max-width:100%;
  flex-direction: column;
  flex: 1;
  
}
#customTable {
  // display: flex;
  // display: -mox-flex;
  // display: -webkit-flex;
  // display: -ms-flexbox;
  // display:block\9;
  // max-width:100%;
  // flex-direction: column;
  // flex: 1;
}
</style>
<style type="text/scss" lang="scss" >
  .has-gutter tr{
      padding: 10px 0;
      background-color:rgb(31, 119, 180) !important;
  }
  .el-range-editor--medium .el-range-input {
    height: 32px;
    border: none;

  }
  .el-range-editor.is-active, .el-range-editor.is-active:hover {
    border: none;
  }
  .area-select .el-input .el-input__inner {
    font-size:12px;
  }
  .el-table__header-wrapper tr th{
    background-color:#d9efff !important;
    border-right:1px solid #afdbfa;
    .cell {
      color: #28323d !important;
    }
   }
   .el-table{
     font-size:12px !important;
   }
   .custom_date .el-input__inner{
    font-size: 12px;
  }
  .userMainTree{
    .el-tree-node__label{
      font-size:12px;
    }
    .el-tree-node__content>.el-tree-node__expand-icon{
      padding:0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/userManagementList/index.vue